import React, { useCallback } from "react";
import { cilCopy } from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import { CButton, CTooltip } from "@coreui/react";
import { useToastActions } from "@src/hooks/useToasts";

interface Props {
  address: string;
}

const MASK_HEAD = 6;
const MASK_TAIL = 6;

const maskAddress = (address: string): string => {
  if (address.length <= MASK_HEAD + MASK_TAIL + 3) {
    return address;
  }
  return `${address.slice(0, MASK_HEAD)}…${address.slice(-MASK_TAIL)}`;
};

export const WithdrawAddressCell: React.FC<Props> = ({ address }) => {
  const { showToast } = useToastActions();

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(address);
      showToast({ message: "Address copied to clipboard", type: "success", timeout: 2000 });
    } catch {
      showToast({ message: "Failed to copy address", type: "danger" });
    }
  }, [address, showToast]);

  return (
    <span className="WithdrawAddressCell d-inline-flex align-items-center gap-2">
      <CTooltip content={address} placement="top">
        <code className="WithdrawAddressCell-text">{maskAddress(address)}</code>
      </CTooltip>
      <CButton
        color="link"
        size="sm"
        className="WithdrawAddressCell-copy p-0"
        title="Copy address"
        aria-label="Copy address"
        onClick={handleCopy}
      >
        <CIcon icon={cilCopy} size="sm" />
      </CButton>
    </span>
  );
};
